import { RequestKind } from '@sb/library/base';
import { SchoolGenerationResultItem, TestSchoolInputItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace TestSchoolGenerationRoutes { 
    export const Create = ApiRoute.Define({
        URL: `testschool`,
        Kind: RequestKind.Post,
        BodyType: TestSchoolInputItem,
        ResultType: SchoolGenerationResultItem
    });
}
